import { SIN_CATEGORIA } from "../constants/constants"
import mapArticulo from "./mapArticulo"

const mapArticulosByCategoria = (
  articulosByCategoria = [],
  articulosSelected = {}
) => {
  const articulosMapped = {}

  articulosByCategoria.forEach((categoria) => {
    // @ts-expect-error TS(2339): Property 'categoriaNombre' does not exist on type ...
    const categoriaNombre = categoria?.categoriaNombre || SIN_CATEGORIA

    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
    articulosMapped[categoriaNombre] = {
      // @ts-expect-error TS(2339): Property 'articulos' does not exist on type 'never...
      articulos: categoria?.articulos?.map((articulo: $TSMigrationFixMe) =>
        mapArticulo({ articulo, articulosSelected, categoriaNombre })
      ),
      // @ts-expect-error TS(2339): Property 'categoriaId' does not exist on type 'nev...
      categoriaId: categoria.categoriaId,
      // @ts-expect-error TS(2339): Property 'totalCount' does not exist on type 'neve...
      totalCount: categoria.totalCount,
      categoriaNombre,
    }
  })

  return articulosMapped
}

export default mapArticulosByCategoria
